import * as React from 'react';
import * as Api from 'src/api';
import ContentSubtypeList from 'src/components/ContentSubtype/list';

export default class ContentSubtypeContainer extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      contentsSubtypes: [],
      pages: 0,
    };

    this.fetch = this.fetch.bind(this);
  }

  public async fetch(params: any): Promise<void> {
    const query: any = {
      limit: 10,
      offset: 10 * (params.page - 1),
      order: 'id DESC',
    };

    const response: any = await Api.listContentSubtypes(query);
    const contentsSubtypes: any[] = response.data;
    const headers = response.headers;
    const pages = Math.ceil(parseInt(headers['x-total-count'], 10) / 10);

    this.setState({ contentsSubtypes, pages });
  }

  public render() {
    return (
      <ContentSubtypeList
        contentsSubtypes={this.state.contentsSubtypes}
        pages={this.state.pages}
        onPageChange={this.fetch}
      />
    );
  }

  public componentDidMount() {
    this.fetch({ page: 1 });
  }
}



// WEBPACK FOOTER //
// ./src/containers/ContentSubtype/index.tsx